import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import SettingsLayout from '@/layouts/SettingsLayout'
import { useOrgPath } from '@/lib/pathFor'

export default function UsersNew() {
  const pathFor = useOrgPath()
  const { data, setData, post, processing } = useForm({
    name: '',
    email_address: '',
    password: '',
    role: 'operator',
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(pathFor('/settings/users'))
  }

  return (
    <>
      <header className="flex h-14 items-center border-b px-8">
        <h1 className="text-sm font-semibold">Add User</h1>
      </header>

      <div className="max-w-md p-8">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name" className="text-xs">Name</Label>
            <Input
              id="name"
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              className="mt-1 h-9 text-[13px]"
            />
          </div>

          <div>
            <Label htmlFor="email_address" className="text-xs">Email</Label>
            <Input
              id="email_address"
              type="email"
              required
              value={data.email_address}
              onChange={(e) => setData('email_address', e.target.value)}
              className="mt-1 h-9 text-[13px]"
            />
          </div>

          <div>
            <Label htmlFor="password" className="text-xs">Password</Label>
            <Input
              id="password"
              type="password"
              required
              value={data.password}
              onChange={(e) => setData('password', e.target.value)}
              className="mt-1 h-9 text-[13px]"
            />
          </div>

          <div>
            <Label htmlFor="role" className="text-xs">Role</Label>
            <select
              id="role"
              value={data.role}
              onChange={(e) => setData('role', e.target.value)}
              className="mt-1 flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-[13px] shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            >
              <option value="operator">Operator</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <div className="flex gap-2 pt-2">
            <Button type="submit" size="sm" disabled={processing}>
              Create User
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => window.history.back()}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

UsersNew.layout = (page: React.ReactNode) => (
  <AuthenticatedLayout>
    <SettingsLayout>{page}</SettingsLayout>
  </AuthenticatedLayout>
)
